import WelcomeModal from 'app/pages/CommandCentre/components/WelcomeModal';
import useCommandCentreWelcomePopUp from 'app/pages/CommandCentre/hooks/useCommandCentreWelcomePopUp';
import NewPlanFeaturesModal, {
  useNewPlanFeaturesPopUp,
} from 'app/shared-components/NewPlanFeaturesModal';
import WebBuilderPromoModal, {
  useWebBuilderPromoPopUp,
} from 'app/shared-components/WebBuilderPromoModal';

/**
 * The pop-ups that introduce something once, shown one at a time in this order: what the new plans
 * added, the Website builder, then the Command Centre welcome. The next one opens once the one
 * before it is closed. While an earlier one is still loading, the later ones wait, so nothing opens
 * only to be covered by another.
 */
export default function IntroPopUps(): JSX.Element | null {
  const newPlanFeatures = useNewPlanFeaturesPopUp();
  const webBuilderPromo = useWebBuilderPromoPopUp();
  const commandCentreWelcome = useCommandCentreWelcomePopUp();

  if (newPlanFeatures.status === 'show') {
    return (
      <NewPlanFeaturesModal
        segment={newPlanFeatures.segment}
        plan={newPlanFeatures.plan}
        onClose={newPlanFeatures.dismiss}
      />
    );
  }
  if (newPlanFeatures.status === 'loading') return null;

  if (webBuilderPromo.status === 'show') {
    return <WebBuilderPromoModal onDismiss={webBuilderPromo.dismiss} />;
  }
  if (webBuilderPromo.status === 'loading') return null;

  if (commandCentreWelcome.status === 'show') {
    return <WelcomeModal open onClose={commandCentreWelcome.dismiss} />;
  }

  return null;
}
